/** @param {(sample: { name: string, value: number, unit?: string }) => void} report */
export function observeLCP(report) {
  try {
    const obs = new PerformanceObserver((list) => {
      const last = list.getEntries().at(-1)
      if (last) report({ name: 'LCP', value: last.startTime, unit: 'ms' })
    })
    obs.observe({ type: 'largest-contentful-paint', buffered: true })
    return () => obs.disconnect()
  } catch {
    return () => {}
  }
}
